var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankProductAndServiceFinancing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-3116.000000, -1100.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bank-Product-and-Service/Financing",
    transform: "translate(3116.000000, 1100.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,9 L24,9 L24,5 L8,5 L8,9 Z M22,16 C20.895,16 20,15.105 20,14 C20,12.896 20.895,12 22,12 C23.104,12 24,12.896 24,14 C24,15.105 23.104,16 22,16 L22,16 Z M22,22 C20.895,22 20,21.105 20,20 C20,18.896 20.895,18 22,18 C23.104,18 24,18.896 24,20 C24,21.105 23.104,22 22,22 L22,22 Z M22,28 C20.895,28 20,27.105 20,26 C20,24.896 20.895,24 22,24 C23.104,24 24,24.896 24,26 C24,27.105 23.104,28 22,28 L22,28 Z M16,16 C14.895,16 14,15.105 14,14 C14,12.896 14.895,12 16,12 C17.105,12 18,12.896 18,14 C18,15.105 17.105,16 16,16 L16,16 Z M16,22 C14.895,22 14,21.105 14,20 C14,18.896 14.895,18 16,18 C17.105,18 18,18.896 18,20 C18,21.105 17.105,22 16,22 L16,22 Z M16,28 C14.895,28 14,27.105 14,26 C14,24.896 14.895,24 16,24 C17.105,24 18,24.896 18,26 C18,27.105 17.105,28 16,28 L16,28 Z M10,16 C8.895,16 8,15.105 8,14 C8,12.896 8.895,12 10,12 C11.105,12 12,12.896 12,14 C12,15.105 11.105,16 10,16 L10,16 Z M10,22 C8.895,22 8,21.105 8,20 C8,18.896 8.895,18 10,18 C11.105,18 12,18.896 12,20 C12,21.105 11.105,22 10,22 L10,22 Z M10,28 C8.895,28 8,27.105 8,26 C8,24.896 8.895,24 10,24 C11.105,24 12,24.896 12,26 C12,27.105 11.105,28 10,28 L10,28 Z M8,0 C5.791,0 4,1.791 4,4 L4,32 L24,32 C26.209,32 28,30.209 28,28 L28,0 L8,0 Z",
    id: 143
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankProductAndServiceFinancing);
export default __webpack_public_path__ + "static/media/bank-product-and-service-financing.da58ae56.svg";
export { ForwardRef as ReactComponent };